import { NavigationLinkProps } from "../../providers/Router";

// Segment routes are now handled inline within the EmployeeDirectoryPage
// using the segmentView state for create and history views
const SegmentsRouter: NavigationLinkProps[] = [];

export default SegmentsRouter;
